import { render } from "./usermenu.vue?vue&type=template&id=3df1356a"
import script from "./usermenu.vue?vue&type=script&lang=js"
export * from "./usermenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__